import { jsx as _jsx } from "react/jsx-runtime";
// Hand-rolled stroke icons (24×24 grid, currentColor). Decorative by default;
// give the surrounding button an aria-label.
const paths = {
    check: "M5 12.5l4.2 4.2L19 7",
    x: "M6 6l12 12M18 6L6 18",
    pencil: "M4 20h4L18.5 9.5a2.1 2.1 0 0 0-3-3L5 17v3zM13.5 7.5l3 3",
    undo: "M9 14L4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
    search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4",
    upload: "M12 16V4M7 9l5-5 5 5M4 16v2.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V16",
    sparkles: "M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8L12 3zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15zM5 15l.6 1.4L7 17l-1.4.6L5 19l-.6-1.4L3 17l1.4-.6L5 15z",
    sun: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1.5v2M12 20.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M1.5 12h2M20.5 12h2M4.6 19.4L6 18M18 6l1.4-1.4",
    moon: "M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z",
    monitor: "M3.5 4.5h17v11h-17zM8.5 20h7M12 15.5V20",
    user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0",
    logout: "M15 4h3.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H15M10 16l-4-4 4-4M6 12h10",
    chevronDown: "M6 9l6 6 6-6",
    chevronRight: "M9 6l6 6-6 6",
    chevronLeft: "M15 6l-6 6 6 6",
    chevronUp: "M6 15l6-6 6 6",
    alert: "M12 4L2.5 20h19L12 4zM12 10v4.5M12 17.5v.01",
    octagon: "M8.2 3h7.6L21 8.2v7.6L15.8 21H8.2L3 15.8V8.2L8.2 3zM12 8v5M12 16.5v.01",
    info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v6M12 7.5v.01",
    doc: "M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8l-5-5zM14 3v5h5M9 13h6M9 17h6",
    zoomIn: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4M8 11h6M11 8v6",
    zoomOut: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4M8 11h6",
    external: "M14 4h6v6M20 4l-9 9M18 14v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10",
    send: "M4 12l16-8-6 16-2.5-6.5L4 12z",
    stop: "M7 7h10v10H7z",
    widen: "M3 12h18M7 8l-4 4 4 4M17 8l4 4-4 4",
    narrow: "M2 12h7M15 12h7M6 8l4 4-4 4M18 8l-4 4 4 4",
    maximize: "M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7",
    grip: "M9 6h.01M9 12h.01M9 18h.01M15 6h.01M15 12h.01M15 18h.01",
    bolt: "M13 2L4 14h7l-1 8 9-12h-7l1-8z",
    clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2",
    mail: "M4 6h16v12H4zM4 7l8 6 8-6",
    message: "M5 5h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8l-4 3v-3H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z",
    rules: "M4 6h10M4 12h7M4 18h10M17 4l3 3-3 3M17 14l3 3-3 3",
    settings: "M4 7h10M18 7h2M16 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM4 12h2M10 12h10M8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM4 17h8M16 17h4M14 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    models: "M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3zM12 12l8-4.5M12 12v9M12 12L4 7.5",
    history: "M3 12a9 9 0 1 0 3-6.7M3 4v4h4M12 8v4l3 2",
    keyboard: "M3 7h18v10H3zM7 10.5h.01M10.5 10.5h.01M14 10.5h.01M17.5 10.5h.01M8 14h8",
    refresh: "M20 11a8 8 0 0 0-14.5-4.5M4 4v3h3M4 13a8 8 0 0 0 14.5 4.5M20 20v-3h-3",
    robot: "M12 3v3M7 8h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2zM9.5 13h.01M14.5 13h.01M9.5 16.5h5M2.5 12.5v2.5M21.5 12.5v2.5",
    gavel: "M14 4l6 6M11.5 6.5l6 6M13 5l-6 6 3 3 6-6M8.5 12.5L3 18l3 3 5.5-5.5",
    inbox: "M3 13l3-8h12l3 8M3 13v5.5A1.5 1.5 0 0 0 4.5 20h15a1.5 1.5 0 0 0 1.5-1.5V13M3 13h5l1.5 2.5h5L16 13h5",
    eye: "M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    copy: "M9 9h10v11H9zM5 15V4h10",
    trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
    plus: "M12 5v14M5 12h14",
    play: "M7 4l12 8-12 8V4z",
    shield: "M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3zM8.5 12l2.5 2.5 4.5-5",
    arrowRight: "M5 12h14M13 6l6 6-6 6",
    link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
    layers: "M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5",
    // a presentation board on a stand: authoring / teaching (e.g. a course studio)
    presentation: "M3 4h18M4.5 4v10.5A1.5 1.5 0 0 0 6 16h12a1.5 1.5 0 0 0 1.5-1.5V4M12 16v3M8.5 21l3.5-2 3.5 2M8 12l2.5-2.5 2 2L16 8",
    ghost: "M5 20V10a7 7 0 0 1 14 0v10l-2.5-1.5L14 20l-2-1.5L10 20l-2.5-1.5L5 20zM9.5 10.5h.01M14.5 10.5h.01",
    comment: "M4 5h16v11H9l-5 4V5z",
    question: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9.3a2.6 2.6 0 0 1 5 .9c0 1.8-2.5 2.3-2.5 4M12 17.3v.01",
    cpu: "M7 7h10v10H7zM10 3v4M14 3v4M10 17v4M14 17v4M3 10h4M3 14h4M17 10h4M17 14h4",
    filter: "M4 5h16l-6 7.5V19l-4 2v-8.5L4 5z",
    forward: "M14 5l7 7-7 7M21 12H9a6 6 0 0 0-6 6",
    menu: "M4 7h16M4 12h16M4 17h16",
    dots: "M5 12h.01M12 12h.01M19 12h.01",
    database: "M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3",
    bell: "M6 9a6 6 0 0 1 12 0c0 5 1.5 6.5 2.5 7.5H3.5C4.5 15.5 6 14 6 9zM9.5 20a2.5 2.5 0 0 0 5 0",
    globe: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3.5 9h17M3.5 15h17M12 3c-2.5 2.3-3.8 5.6-3.8 9s1.3 6.7 3.8 9c2.5-2.3 3.8-5.6 3.8-9S14.5 5.3 12 3z",
    home: "M4 11.5 12 4l8 7.5M6 10v9a1 1 0 0 0 1 1h3v-6h4v6h3a1 1 0 0 0 1-1v-9",
    book: "M5 4h11a2 2 0 0 1 2 2v14H7a2 2 0 0 1-2-2V4zM5 16h13M9 4v12",
    route: "M7 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM17 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM17 9v4a4 4 0 0 1-4 4H9a2 2 0 0 0-2 2v2",
    award: "M12 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM9 14.2 7.5 21l4.5-2.6L16.5 21 15 14.2",
    trophy: "M7 4h10v5a5 5 0 0 1-10 0V4zM7 6H4v2a3 3 0 0 0 3 3M17 6h3v2a3 3 0 0 1-3 3M10 14.5V18h4v-3.5M8 21h8M9 18h6",
    camera: "M4 8.5A1.5 1.5 0 0 1 5.5 7h2.3L9.5 4.5h5L16.2 7h2.3A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5v-9zM12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    image: "M5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-13A1.5 1.5 0 0 1 5.5 4zM4 16l4.5-4.5 4 4 2.5-2.5L20 18M15.5 9.5v.01",
    paperclip: "M20 11.5l-8.2 8.2a4.6 4.6 0 0 1-6.5-6.5l8.6-8.6a3.1 3.1 0 0 1 4.4 4.4l-8.6 8.6a1.5 1.5 0 0 1-2.2-2.2l7.9-7.9",
};
/**
 * Render an {@link IconLike}. `IconName` is a string union and `ReactNode`
 * already includes string, so the type alone cannot tell a built-in name from
 * a plain-string node — the runtime `icon in paths` check is what distinguishes
 * them: a string that is a known glyph name renders the built-in <Icon> at the
 * given size; any other node (a React element / custom SVG) renders as-is; a
 * string that is not a known glyph, or undefined, renders nothing. Keep it
 * dependency-free.
 */
export function renderIcon(icon, size, props) {
    if (icon == null)
        return null;
    if (typeof icon === "string") {
        return icon in paths ? (_jsx(Icon, { name: icon, size: size, ...props })) : null;
    }
    return icon;
}
export function Icon({ name, size = 16, strokeWidth = 2, ...rest }) {
    return (_jsx("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false", ...rest, children: _jsx("path", { d: paths[name] }) }));
}
